export enum TimeSlotDisplayType {
  Default = 'Default',
  TimePeriod = 'TimePeriod',
}
